import { useLayoutEffect, useState } from 'react';

interface ResponsiveSlidesOptions {
  slidesToShow: number;
  gap: number;
  containerRef: React.RefObject<HTMLDivElement | null>;
}

export const useResponsiveSlides = ({
  containerRef,
  slidesToShow,
  gap,
}: ResponsiveSlidesOptions) => {
  const [slideWidth, setSlideWidth] = useState(containerRef.current?.offsetWidth || 0);

  useLayoutEffect(() => {
    if (!containerRef.current) return;

    const calculateSlideWidth = () => {
      const containerWidth = containerRef.current?.offsetWidth || 0;

      // Calculate slide width based on container width, number of slides to show, and gap
      const calculatedWidth = (containerWidth - gap * (slidesToShow - 1)) / slidesToShow;
      setSlideWidth(calculatedWidth);
    };

    calculateSlideWidth();

    const resizeObserver = new ResizeObserver(calculateSlideWidth);
    resizeObserver.observe(containerRef.current);

    return () => resizeObserver.disconnect();
  }, [containerRef, slidesToShow, gap]);

  return slideWidth;
};
